import React from "react"
import PropTypes from "prop-types"
import SocialLinks from "./SocialLinks"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFacebookSquare, faTwitterSquare, faInstagramSquare } from "@fortawesome/free-brands-svg-icons"
import questions from './questions';


class Score extends React.Component {
  render () {

    if(!this.props.survey) return null;

    const toCheck = [
      'fact_1_score',
      'fact_2_score',
      'fact_3_score',
      'fact_4_score',
      'fact_5_score',
      'fact_6_score',
    ]

    const scores = toCheck.map(column => this.props.survey[column]);
    const score = _.mean(scores);
    const round = Math.round(score);

    let message;
    if(round > 90) message = 'Astounding!';
    else if(round > 75) message = 'Amazing!';
    else if(round > 50) message = 'Really Good!';
    else if(round > 30) message = 'Good Effort!';
    else message = 'Sorry';

    return (
      <div id='score'>

        <h3
          className='text-center mmb'
        >
          {`${message}`}
        </h3>


        <h1
          className='text-center lmb'
        >
          {`You scored ${round}%`}
        </h1>

      </div>
    );
  }
}

export default Score;
